import React, { useState } from "react";

interface InfoOverlayProps {
  children: React.ReactNode;
}

export const InfoOverlay: React.FC<InfoOverlayProps> = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="Show info"
        onClick={() => setOpen(true)}
        style={{
          marginLeft: 8,
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <span
          style={{
            display: "inline-block",
            width: 22,
            height: 22,
            borderRadius: "50%",
            backgroundColor: "#007bff",
            color: "white",
            textAlign: "center",
            lineHeight: "22px",
            fontSize: 14,
            fontWeight: "bold",
          }}
          aria-hidden="true"
        >
          i
        </span>
      </button>
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setOpen(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: 8,
              padding: "2rem",
              maxWidth: 400,
              width: "calc(100% - 20px)",
              margin: "10px",
              boxSizing: "border-box",
              boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
              textAlign: "center",
              position: "relative",
              maxHeight: "calc(100% - 20px)",
              overflow: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              aria-label="Close info"
              onClick={() => setOpen(false)}
              style={{
                position: "absolute",
                top: 8,
                right: 12,
                background: "none",
                border: "none",
                fontSize: 28,
                color: "#888",
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ×
            </button>
            <div
              style={{
                fontSize: "1rem",
                marginTop: 16,
                textAlign: "left",
                fontWeight: "normal",
                color: "black",
              }}
            >
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoOverlay;
